// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WbVg4","left":"styles_left__1Yo_k"};